import gql from 'graphql-tag';

export default fields => gql`
query {
  listPurchaseModels {
    items {
      __typename
      ${[...['id', 'name'].concat(fields)]}     
    }
  }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/PurchaseModels/AllQuery.js